import React, { useEffect, useState } from "react";
import { Button, Form, Image, Input, notification, Select, Upload, Space } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { GrUpload } from "react-icons/gr";
import CategoryRequest from "../../Categories/CategoryRequest";
import { useNavigate, useParams } from "react-router-dom";


const EditCustomerAddress = () => {

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();

    const [fileList, setFileList] = useState([]);
    const [form] = Form.useForm();






    const uploadButton = (
        <button style={{ border: 0, background: "none" }}>
            <GrUpload />
            <div style={{ marginTop: 8 }}>Upload</div>
        </button>
    );


    return (
        <section>
            <div className="Create-Category">
                <div span={24}>
                    <Form.Item className="text-center submit-btn">
                        <Space>
                            <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                                <ArrowLeftOutlined />
                            </Button>
                        </Space>
                    </Form.Item>
                </div>
                <h3>Edit Customer Address</h3>

                <Form
                    form={form}
                    //   onFinish={onFinish}
                    layout="vertical"
                    initialValues={null}
                    className="subscription-form"
                    colon
                >
             <div className="subscription">

  <Form.Item
    label="House Number"
    name="hno"
    className="subscription-plan"
    rules={[
      { required: true, message: "Please enter the customer house number!" },
      {
        pattern: /^[A-Za-z0-9\s#\-\/]+$/,
        message: "House number can only contain letters, numbers, spaces, '-', '/', and '#'!",
      },
    ]}
  >
    <Input size="large" placeholder="Enter customer house number" />
  </Form.Item>

  {/* Street Validation */}
  <Form.Item
    label="Street"
    name="street"
    className="subscription-plan"
    rules={[
      { required: true, message: "Please enter the street!" },
      {
        pattern: /^[A-Za-z0-9\s\-]+$/,
        message: "Street name can only contain letters, numbers, spaces, and '-'!",
      },
    ]}
  >
    <Input size="large" placeholder="Enter street name" />
  </Form.Item>
</div>
                    <div className="subscription">
                        <Form.Item
                            label="State"
                            name="state"
                            className="subscription-plan"
                            rules={[
                                { required: true, message: "Please enter the state!" },
                                {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "State can only contain alphabetic characters!",
                                },
                            ]}
                        >
                            <Input size="large" placeholder="Enter customer state" />
                        </Form.Item>
                        <Form.Item
                            label="City"
                            name="city"
                            className="subscription-plan"
                            rules={[{ required: true, message: "Please enter the city!" },
                            {
                                pattern: /^[A-Za-z\s]+$/,
                                message: "City can only contain alphabetic characters!",
                            },
                            ]}
                        >
                            <Input size="large" placeholder="Enter customer city" />
                        </Form.Item>


                    </div>
                    <div className="subscription">
                        <Form.Item
                            label="Near"
                            name="near"
                            className="subscription-plan"
                            rules={[
                                { required: true, message: "Please enter the nearyby area!" },
                                {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "area can only contain alphabetic characters!",
                                },
                            ]}
                        >
                            <Input size="large" placeholder="Enter customer nearby area" />
                        </Form.Item>
                        <Form.Item
                            label="Pincode"
                            name="pincode"
                            className="subscription-plan"
                            rules={[
                                { required: true, message: "Please enter the pincode!" },
                                {
                                    pattern: /^[0-9]{6}$/, // Ensures exactly 6 digits
                                    message: "Pincode must be a 6-digit number!",
                                },
                            ]}
                        >
                            <Input size="large" placeholder="Enter pincode" maxLength={6} />
                        </Form.Item>

                    </div>

                    <div className="subscription">
  <Form.Item
    label="Latitude"
    name="latitude"
    className="subscription-plan"
    rules={[
      { required: true, message: "Please enter the latitude!" },
      {
        pattern: /^-?([1-8]?\d(\.\d+)?|90(\.0+)?)$/,
        message: "Latitude must be a number between -90 and 90!",
      },
    ]}
  >
    <Input size="large" placeholder="Enter latitude" />
  </Form.Item>

  <Form.Item
    label="Longitude"
    name="longitude"
    className="subscription-plan"
    rules={[
      { required: true, message: "Please enter the longitude!" },
      {
        pattern: /^-?(180(\.0+)?|((1[0-7]\d)|(\d{1,2}))(\.\d+)?)$/,
        message: "Longitude must be a number between -180 and 180!",
      },
    ]}
  >
    <Input size="large" placeholder="Enter longitude" />
  </Form.Item>
</div>



                    <div className="bottom-button">
                        <div style={{ padding: "10px" }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Save & Proceed
                                <span>
                                    <AiOutlineRight />
                                </span>
                            </Button>
                        </div>
                    </div>
                </Form>
            </div>
        </section>
    );
};

export default EditCustomerAddress;
